import { useEffect, useState } from "react";

import { adaptDecisionAnalyticsV1 } from "../adapters/decisionAnalyticsAdapter";
import { fetchDecisionAnalytics } from "../services/decisionAnalyticsApi";

export default function useDecisionAnalytics() {
  const [state, setState] = useState({ status: "loading", data: null, error: null });

  useEffect(() => {
    let active = true;
    fetchDecisionAnalytics()
      .then((payload) => {
        if (active) setState({ status: "ready", data: adaptDecisionAnalyticsV1(payload), error: null });
      })
      .catch((error) => {
        if (active) setState({ status: "unavailable", data: null, error });
      });
    return () => { active = false; };
  }, []);

  return state;
}
